<template>
  <b-form @submit.prevent="onSubmit">

    <b-row>
      <form-group class="  col-lg-3" :validations="$v.form.date_of_payment">
        <div slot-scope="{ errors, invalid }">
          <b-form-group label="تاریخ قسط">

            <date-picker clearable auto-submit v-model="form.date_of_payment"
                         placeholder="تاریخ قسط"
                         type="datetime"
                         format="YYYY-MM-DD HH:mm:ss" display-format="jYYYY/jM/jD HH:mm:ss"/>
            <form-errors-manager :errors="errors"/>

          </b-form-group>
        </div>
      </form-group>

      <form-group class="  col-lg-33" :validations="$v.form.value">
        <div slot-scope="{ errors, invalid }">
          <b-form-group label="مبلغ قسط">

            <b-form-input v-model="form.value"/>
            {{ formatNumber(form.value) }}
            <form-errors-manager :errors="errors"/>

          </b-form-group>
        </div>
      </form-group>


      <form-group class="  col-lg-3" :validations="$v.form.loan_assets">
        <div slot-scope="{ errors, invalid }">
          <b-form-group label="فایل ضمیمه">


            <b-form-file v-model="form.loan_assets" multiple size="sm"></b-form-file>
            <b-button class="my-1 rounded-pill" @click="clearSelectedFiles()" size="sm">حذف فایل های انتخابی</b-button>


            <form-errors-manager :errors="errors"/>

          </b-form-group>
        </div>
      </form-group>
      <b-form-group class="col-lg-1" label="تکرار" v-if="inCreateMode">

        <b-form-input min="1" required type="number" v-model="howManyTimeCreateThisForm"/>

      </b-form-group>

      <div class="col-lg-12 text-center my-3">
        <b-btn class="px-5" pill type="submit">ثبت</b-btn>
      </div>

      <hr>

      <div class="col-12 text-center" v-if="item">
        <table class="table col-12  table-responsive-md table-striped">
          <thead>
          <tr>
            <th scope="col">فایل</th>
            <th scope="col">#</th>
          </tr>
          </thead>
          <tbody>

          <tr v-for="(asset,index) in item.assets">
            <th>
              <m-a target="_blank" :href="asset.file">
                فایل ضمیمه {{ index + 1 }}
              </m-a>
            </th>
            <td>
              <m-a target="_blank" :href="asset.file">
                <span class="btn mx-1 rounded-pill btn-primary">مشاهده</span>
              </m-a>
              <span @click="removeLoanAsset(asset)" class="btn mx-1 rounded-pill btn-danger">حذف</span>
            </td>
          </tr>

          </tbody>
        </table>
      </div>

    </b-row>

  </b-form>
</template>

<script>
import FormErrorsManager from "../../validator/FormErrorsManager";
import FormGroup from "../../validator/FormGroup";
import {required, numeric, minValue} from "vuelidate/lib/validators";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";

export default {
  name: "LoanCreateForm",
  components: {FormErrorsManager, FormGroup, datePicker: VuePersianDatetimePicker,},
  props: {
    order_id: {},
    item: {
      default: null
    }
  },
  data() {
    return {
      form: {
        date_of_payment: '',
        value: 0,
        loan_assets: [],
      },
      howManyTimeCreateThisForm: 1,
    };
  },
  validations: {
    form: {
      date_of_payment: {required},
      value: {required, numeric, minValue: minValue(1000)},
      loan_assets: {},
    },
  },
  computed: {
    inCreateMode() {
      return this.item == null
    }
  },
  methods: {
    formatNumber,
    invalid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    async refreshPageItems() {
      let form = {
        user_id: this.$route.params.user,
        order_id: this.$route.params.order
      }
      await this.$store.dispatch('Loan/getLoanItems', form)
    },
    async onSubmit() {
      if (this.invalid()) {
        let form = {
          ...this.form,
          order_id: this.order_id
        }

        if (this.inCreateMode) {
          for (let i = 0; i < this.howManyTimeCreateThisForm; i++) {
            await this.$store.dispatch('Loan/createLoan', form)
          }
        } else {
          await this.$store.dispatch('Loan/updateLoan', form)
        }

        // refresh page items
        await this.refreshPageItems()
      }
    },
    async removeLoanAsset(asset) {
      if (confirm('آیا از حذف اطمینان دارید؟')) {

        let form = {
          loan_id: asset.fileable_id,
          loan_assets_id: asset.id
        }

        await this.$store.dispatch('Loan/removeLoanAsset', form)

        // refresh page items
        await this.refreshPageItems()

      }
    },
    clearSelectedFiles() {
      this.form.loan_assets = []
    }
  },
  mounted() {
    if (this.item != null) {
      // set form for update item
      this.form.value = this.item.value
      this.form.date_of_payment = this.item.date_of_payment
      this.form.loan_id = this.item.id
    }
  }
}
</script>

<style scoped>

</style>